import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectSummariesTransactions } from 'app/selectors/ugc/SummariesSelector';
import SummariesActions from 'app/actions/SummariesActions';
import ModalActions from 'app/actions/ModalActions';
import DeleteSummaryModal from './DeleteSummaryModal';

export class DeleteSummaryModalContainer extends React.PureComponent {
  render() {
    return <DeleteSummaryModal {...this.props} />;
  }
}

DeleteSummaryModalContainer.propTypes = {
  // ownProps
  summaryId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,

  // Redux props
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  summariesTransactions: selectSummariesTransactions(state)
});

const mapDispatchToProps = dispatch => ({
  summariesActions: bindActionCreators(SummariesActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSummaryModalContainer);
